"use client"
import { Block } from "@opensea/ui-kit"
import { useContext } from "react"
import { HandoffContext } from "./HandoffProvider"
import { useHandoffMutator } from "./use-handoff"

type HandoffButtonProps = {
  children: React.ReactNode
  enabled?: boolean
  asChild?: boolean
}

export function HandoffButton({
  children,
  enabled: enabledProp = true,
  asChild = false,
}: HandoffButtonProps) {
  const context = useContext(HandoffContext)
  const enabled = context.enabled ?? enabledProp
  const handoff = context.handoff

  const set = useHandoffMutator({
    enabled,
  })

  function handleHandoffStore() {
    set(handoff)
  }

  return (
    <Block asChild={asChild} className="inline" onClick={handleHandoffStore}>
      {children}
    </Block>
  )
}
